import React from "react";
import SearchWidgetTabs from "../searchwidgetTabs/searchWidgetTabs";
import DateTime from "src/utils/temporalLuxonUtil";
import Icon from "src/components/icon";
import CTAButton from "src/components/ctabutton";

// TODO: create these datetimefn into datefns.

type SkiResortsSearchWidgetSeasonPassProps = {
    selectedLanguage: string;
    defaultLanguage: string
}

type SkiResortsSearchWidgetSeasonPassState = {
    option: "0",
}

class SkiResortsSearchWidgetSeasonPass extends React.Component<SkiResortsSearchWidgetSeasonPassProps, SkiResortsSearchWidgetSeasonPassState> {

    state: SkiResortsSearchWidgetSeasonPassState = {
        option: "0",
    }

    get link() {
        if (this.state.option === "0") return "#";
    }

    render() {
        return <>
        <div className={`flex flex-col lg:flex-row gap-4 justify-between items-center p-4 sm:p-6 rounded-b-2xl`}>
            <div className="w-full lg:w-1/3">
              <select value={this.state.option} onChange={(e) => this.setState({option: e.target.value as any})} className="w-full rounded-lg bg-[#fff] text-[#5449CD] global-bselect caption h-10">
                <option defaultValue={"Pass type"} value="0">Pass type</option>
              </select>
            </div>
            <div className="w-full lg:w-1/3">
              <select value={this.state.option} className="w-full rounded-lg bg-[#fff] text-[#5449CD] global-bselect caption h-10">
                <option defaultValue={"Pass type"} value="0">Adults</option>
              </select>
            </div>
            <div className="w-full lg:w-1/3">
              <select value={this.state.option} className="w-full rounded-lg bg-[#fff] text-[#5449CD] global-bselect caption h-10">
                <option defaultValue={"Pass type"} value="0">Children</option>
              </select>
            </div>
            <div className="w-full lg:w-1/4">
                <CTAButton link={this.link} className="w-full" roundType="rounded" color="#1B427A" bgcolor='#6DDCE7' hovercolor="#6DDCE7" hoverbgcolor='#FFFFFF' type="primary" text="Book Now!" />
            </div>
          </div>
        </>
    }
}

type SkiResortSearchWidgetLodgingProps = {
    selectedLanguage: string;
    defaultLanguage: string
}

type SkiResortSearchWidgetLodgingState = {
    option: "0" | "1" | "2"
}

class SkiResortSearchWidgetLodging extends React.Component<SkiResortSearchWidgetLodgingProps, SkiResortSearchWidgetLodgingState> {

    state: SkiResortsSearchWidgetSeasonPassState = {
        option: "0",
    }

    get link() {
        if (this.state.option === "0") return "#";
    }

    render() {
        return <>
        <div className={`flex flex-col lg:flex-row gap-4 justify-between items-center p-4 sm:p-6 rounded-b-2xl #5449CD`}>
            <div className="w-full lg:w-1/3">
              <select value={this.state.option} onChange={(e) => this.setState({option: e.target.value as any})} className="w-full rounded-lg bg-[#fff] text-[#5449CD] global-bselect caption h-10">
                <option defaultValue={"Pass type"} value="0">Pass type</option>
              </select>
            </div>
            <div className="w-full lg:w-1/3">
              <select value={this.state.option} className="w-full rounded-lg bg-[#fff] text-[#5449CD] global-bselect caption h-10">
                <option defaultValue={"Pass type"} value="0">Adults</option>
              </select>
            </div>
            <div className="w-full lg:w-1/3">
              <select value={this.state.option} className="w-full rounded-lg bg-[#fff] text-[#5449CD] global-bselect caption h-10">
                <option defaultValue={"Pass type"} value="0">Children</option>
              </select>
            </div>
            <div className="w-full lg:w-1/4">
                <CTAButton link={this.link} className="w-full" roundType="rounded" color="#1B427A" bgcolor='#6DDCE7' hovercolor="#6DDCE7" hoverbgcolor='#FFFFFF' type="primary" text="Book Now!" />
            </div>
          </div>
        </>
    }
}

type SearchWidgetProps = {
    selectedLanguage: string;
    defaultLanguage: string;
    removeMargin: boolean;
}

type SearchWidgetState = {
    tab: "SeasonPass" | "rides" | "tickets" | "stay" | "addons";
    startDate: Date | undefined;
    endDate: Date | undefined;
    adults: number | undefined;
    children: number | undefined;
    ages: number[] | undefined;
}

export default class SkiResortsSearchWidget extends React.Component<SearchWidgetProps, SearchWidgetState> {

    static minimumDate() {
        const baseDate = new Date();
        const hour = baseDate.getHours();
        const today = DateTime.fromJSDate(baseDate).startOf("day").toJSDate();
        const tomorrow = DateTime.fromJSDate(baseDate).startOf("day").plus({ day: 1 }).startOf("day").toJSDate();
        const minimumStart = hour >= 15 ? tomorrow : today;
        return minimumStart;
    }

    static getEndDate() {
        return DateTime.fromJSDate(SkiResortsSearchWidget.minimumDate()).plus({day: 1}).toJSDate()
    }

    static maximumDate() {
        const baseDate = new Date();
        const nextYears = DateTime.fromJSDate(baseDate).startOf("day").plus({ year: 2 }).startOf("day").toJSDate();
        return nextYears;
    }

    state: SearchWidgetState = {
        tab: "stay",
        startDate: undefined,
        endDate: undefined,
        adults: 1,
        children: 0,
        ages: undefined,
    }

    setStartDate = (date: Date) => {
        const ts = date.getTime();
        if (this.state.endDate) {
            const ets = this.state.endDate.getTime();
            if (ts > ets) {
                const plus1 = DateTime.fromJSDate(date).plus({day: 1}).toJSDate()
                this.setState({startDate: date, endDate: plus1});
            }
        }
        this.setState({startDate: date});
    }

    setEndDate = (date: Date) => this.setState({endDate: date})
    setAdults = (adults: number) => this.setState({adults})
    setChilds = (childs: number, ages: number[]) => this.setState({children: childs, ages})

    render() {
        return <>
        <div className={`${this.props.removeMargin ? "" : "mt-[-88px]"} flex w-full justify-center lg:px-10 relative z-[2] flex-col`}>
            <div className="w-[95%] sm:max-w-[400px] lg:max-w-6xl justify-center m-auto flex flex-col">
                <SearchWidgetTabs
                    activeTabLineColor="#FFF"
                    activeFocusTextColor="#FFF"
                    activeFocusBackgroundColor="#d0940f"
                    desktopActiveTabTextColor="#FFF"
                    desktopActiveTabBackgroundColor="#5449CD"
                    desktopInactiveTabTextColor="#FFF"
                    desktopInactiveTabBackgroundColor="#6D62E4"
                    mobileActiveTabBackgroundColor="#5449CD"
                    mobileActiveTabTextColor="#FFF"
                    mobileInactiveTabBackgroundColor="#6D62E4"
                    mobileInactiveTabTextColor="#FFF"
                    desktopBackgroundColor="#5449CD"
                    mobileBackgroundColor="#5449CD"
                >
                    <SearchWidgetTabs.Tab
                        label="SEASON PASS"
                        icon={<Icon width={26} height={26} icon="LiftTicket" />}
                        desktopLabelClassname="searchWidgetText text-center" mobileLabelClassname="searchWidgetText"
                    >
                        <SkiResortsSearchWidgetSeasonPass
                            selectedLanguage={this.props.selectedLanguage}
                            defaultLanguage={this.props.defaultLanguage}
                        />
                    </SearchWidgetTabs.Tab>
                    <SearchWidgetTabs.Tab
                        label="LODGING"
                        icon={<Icon width={26} height={26} icon="Bed" />}
                        desktopLabelClassname="searchWidgetText text-center" mobileLabelClassname="searchWidgetText"
                    >
                        <SkiResortSearchWidgetLodging
                            selectedLanguage={this.props.selectedLanguage}
                            defaultLanguage={this.props.defaultLanguage}
                        />
                    </SearchWidgetTabs.Tab>
                    <SearchWidgetTabs.Tab
                        label="RENTALS"
                        icon={<Icon width={26} height={26} icon="Boot" />}
                        desktopLabelClassname="searchWidgetText text-center" mobileLabelClassname="searchWidgetText"
                    >
                        <SkiResortSearchWidgetLodging
                            selectedLanguage={this.props.selectedLanguage}
                            defaultLanguage={this.props.defaultLanguage}
                        />
                    </SearchWidgetTabs.Tab> <SearchWidgetTabs.Tab
                        label="SHUTTLE"
                        icon={<Icon width={26} height={26} icon="Bus" />}
                        desktopLabelClassname="searchWidgetText text-center" mobileLabelClassname="searchWidgetText"
                    >
                        <SkiResortSearchWidgetLodging
                            selectedLanguage={this.props.selectedLanguage}
                            defaultLanguage={this.props.defaultLanguage}
                        />
                    </SearchWidgetTabs.Tab>
                </SearchWidgetTabs>
            </div>
        </div>
        </>
    }

}